import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { MEMBERS_PERMISSIONS } from "@/app/nav";
import { MemberDetailPage } from "@/features/members/MemberDetailPage";
import { MemberSearch } from "@/features/members/MemberSearch";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type MembersSearch = { q?: string } & PageSearch;

export const membersRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "members",
  // Set, never omit, the key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): MembersSearch => ({
    q: typeof search.q === "string" && search.q.trim() !== "" ? search.q.trim() : undefined,
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, MEMBERS_PERMISSIONS),
  component: MemberSearch,
});

export const memberDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "members/$memberId",
  beforeLoad: ({ context }) => requirePermissions(context.session, MEMBERS_PERMISSIONS),
  component: MemberDetailPage,
});
